<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.ipAdress"
          :label="$t('administration.user.ipadress')"
          type="text"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.login"
          :label="$t('administration.user.login')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>

  </v-container>
</template>

<script>
import InputDate from '../InputDate';
export default {
  name: 'ForgotPasswordFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
  }
};
</script>
